import styled from '@emotion/styled';
import { ButtonWithPopup, colors, Text } from '@innovationdepartment/proxima-ui';
import { ButtonWithPopupWrapperViewProps } from './types';

const ButtonWithPopupWrapper = styled.div<{ open?: boolean }>`
  display: flex;
  height: 22px;
  align-items: center;
  border-radius: 12px;
  gap: 2px;
  padding: 0 4px;
  border: 2px solid ${colors.neutral20};
  align-self: flex-end;

  & svg * {
    transition: fill 0.1s ease-in-out;
  }

  ${({ open }) => {
    if (!open) return ``;

    return `
      background-color: ${colors.neutral80};
      border-color: ${colors.neutral80};
    `;
  }}
`;

const ButtonWrapper = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  flex-grow: 1;
`;

const ChildrenWrapper = styled.div<{ flexibleWidth?: boolean }>`
  padding: 0 8px;

  ${({ flexibleWidth }) => {
    if (flexibleWidth) return 'width: 100%;';
    return 'max-width: 400px;';
  }}
`;

const ButtonWithPopupWrapperView = (props: ButtonWithPopupWrapperViewProps) => {
  const { open, onOpen, onClose, children, buttonText, buttonIcon, flexibleWidth } = props;

  return (
    <ButtonWithPopupWrapper open={open}>
      <ButtonWithPopup
        open={open}
        onClose={onClose}
        onOpen={onOpen}
        buttonElement={
          <ButtonWrapper>
            {buttonIcon}
            <Text variant="body3Semibold" color={open ? 'white' : 'neutral80'}>
              {buttonText}
            </Text>
          </ButtonWrapper>
        }
      >
        <ChildrenWrapper flexibleWidth={flexibleWidth}>{children}</ChildrenWrapper>
      </ButtonWithPopup>
    </ButtonWithPopupWrapper>
  );
};

export default ButtonWithPopupWrapperView;
